__turbopack_context__.v({
  "className": "public_sans_82fb09d2-module__yuNiJa__className",
  "variable": "public_sans_82fb09d2-module__yuNiJa__variable",
});
